"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const repository_1 = require("../../repository");
class DeleteInteractor {
    constructor(repository) {
        this.repository = repository;
    }
    async execute(queryOrId = new repository_1.VoidQuery(), operation = new repository_1.DefaultOperation()) {
        return await this.repository.delete(queryOrId, operation);
    }
}
exports.DeleteInteractor = DeleteInteractor;
